module.exports = __webpack_public_path__ + "static/media/Follower_Button-17.5391ac46.png";